import { useMemo } from "react";
import { motion } from "framer-motion";

const COLORS = ["#E8B4B8", "#E9C3C7", "#D4AF37", "#F3D9DC"];

const Flower = ({ size = 44, petal = "#E8B4B8", center = "#D4AF37" }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" aria-hidden="true">
        {[0, 72, 144, 216, 288].map((a) => (
            <ellipse key={a} cx="20" cy="10.5" rx="6" ry="10.5" fill={petal} opacity="0.9" transform={`rotate(${a} 20 20)`} />
        ))}
        <circle cx="20" cy="20" r="4.6" fill={center} />
    </svg>
);

const FLOWERS = [
    { id: "f1", left: "2%", top: "9%", size: 56, petal: "#E8B4B8", blur: 0, duration: 26, opacity: 0.7 },
    { id: "f2", left: "90%", top: "17%", size: 40, petal: "#F3D9DC", blur: 1.2, duration: 32, opacity: 0.55 },
    { id: "f3", left: "4%", top: "27%", size: 44, petal: "#DFA0A6", blur: 0.8, duration: 28, opacity: 0.6 },
    { id: "f4", left: "88%", top: "37%", size: 62, petal: "#E8B4B8", blur: 0, duration: 24, opacity: 0.7 },
    { id: "f5", left: "3%", top: "47%", size: 38, petal: "#E9C3C7", blur: 1.4, duration: 34, opacity: 0.5 },
    { id: "f6", left: "91%", top: "70%", size: 52, petal: "#DFA0A6", blur: 0.6, duration: 27, opacity: 0.65 },
    { id: "f7", left: "2%", top: "79%", size: 64, petal: "#E8B4B8", blur: 0, duration: 25, opacity: 0.7 },
    { id: "f8", left: "89%", top: "88%", size: 42, petal: "#F3D9DC", blur: 1, duration: 31, opacity: 0.55 },
    { id: "f9", left: "5%", top: "94%", size: 48, petal: "#E9C3C7", blur: 0.8, duration: 29, opacity: 0.6 },
];

export default function Petals({ opened }) {
    const petals = useMemo(
        () =>
            Array.from({ length: 14 }, (_, i) => ({
                id: i,
                left: Math.random() * 100,
                size: 9 + Math.random() * 12,
                duration: 12 + Math.random() * 9,
                delay: Math.random() * 14,
                sway: 30 + Math.random() * 55,
                rotate: 140 + Math.random() * 220,
                color: COLORS[i % COLORS.length],
                opacity: 0.4 + Math.random() * 0.35,
            })),
        []
    );

    if (!opened) return null;

    return (
        <>
            <div className="pointer-events-none fixed inset-0 z-20 overflow-hidden" aria-hidden="true" data-testid="falling-petals">
                {petals.map((p) => (
                    <motion.span
                        key={p.id}
                        className="absolute -top-10"
                        style={{ left: `${p.left}%`, opacity: p.opacity }}
                        animate={{
                            y: ["-6vh", "108vh"],
                            x: [0, p.sway, -p.sway * 0.6, p.sway * 0.3, 0],
                            rotate: [0, p.rotate],
                        }}
                        transition={{ duration: p.duration, delay: p.delay, repeat: Infinity, ease: "linear" }}
                    >
                        <svg width={p.size} height={p.size * 1.4} viewBox="0 0 24 34">
                            <path d="M12 1 C19 8 21 18 12 33 C3 18 5 8 12 1 Z" fill={p.color} />
                        </svg>
                    </motion.span>
                ))}
            </div>

            <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden="true" data-testid="page-flowers">
                {FLOWERS.map((f) => (
                    <motion.span
                        key={f.id}
                        className="absolute"
                        style={{ left: f.left, top: f.top, opacity: f.opacity, filter: f.blur ? `blur(${f.blur}px)` : "none" }}
                        animate={{ rotate: 360, y: [0, -10, 0] }}
                        transition={{
                            rotate: { duration: f.duration, repeat: Infinity, ease: "linear" },
                            y: { duration: 6, repeat: Infinity, ease: "easeInOut" },
                        }}
                    >
                        <Flower size={f.size} petal={f.petal} />
                    </motion.span>
                ))}
            </div>
        </>
    );
}
